const state = () => {
	return {
		containers: {},
		itemListIsLoading: false,
		itemList: []
	};
};

const mutations = {
	setItemList(state, { itemList = [], containers = {} }) {
		state.itemList = itemList;
		state.containers = containers;
	},

	setItemListIsLoading(state, isLoading) {
		state.itemListIsLoading = isLoading;
	}
};

const getters = {
	getItemList: state => maxItems => {
		return state.itemList.slice(0, maxItems);
	},
	getContainers: state => {
		return state.containers;
	},
	getItemCount: state => {
		return state.itemList.length || 0;
	},
	isLoading: state => {
		return state.itemListIsLoading;
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	getters
};
